const TRANSLATE = {
  'permissions.list.title': 'Listing',
  'permissions.list.description': 'Can see the listing',
  'permissions.create.title': 'Creation',
  'permissions.create.description': 'Can create a new one',
  'permissions.edit.title': 'Editing',
  'permissions.edit.description': 'Can edit an existing one',
  'permissions.delete.title': 'Removal',
  'permissions.delete.description': 'Can remove a new one',
  'permissions.import.title': 'Import',
  'permissions.import.description': 'Can do an excel import',
  'permissions.canEditServiceOrderImport.title': 'Editing by import',
  'permissions.canEditServiceOrderImport.description': 'Can perform edits by import',
  'permissions.export.title': 'Export',
  'permissions.export.description': 'Can do an excel export',
  'permissions.setup.title': 'General settings',
  'permissions.setup.description': 'Can change additional fields, levels, etc.',
  'permissions.seeDashboard.title': 'Dashboard view',
  'permissions.seeDashboard.description': 'Can see dashboard charts',
  'permissions.seeComplianceDashboard.title': 'Compliance view',
  'permissions.seeComplianceDashboard.description': 'Can see compliance charts on dashboard',
  'permissions.seeMap.title': 'Map view',
  'permissions.map.description': 'User map view',
  'permissions.createTemplateRecord.title': 'Document generation',
  'permissions.createTemplateRecord.description': 'Can generate DOCX documents',
  'permissions.createServiceOrderForOthers.title': 'Creating activities for other users',
  'permissions.createServiceOrderForOthers.description': '**Mobile app exclusive**',
  'permissions.useFastServiceOrder.title': 'Fast activity creation',
  'permissions.useFastServiceOrder.description':
    '**Mobile app exclusive**. When creating activities on mobile, jumps directly to execution.',
  'permissions.createLeanServiceOrder.title': 'Lean activity creation',
  'permissions.createLeanServiceOrder.description':
    '**Web exclusive**. Enables a leaner activity creation form automatically filling user and place.',
  'permissions.hideSaveOnLeanServiceOrder.title': 'Allow only "Save and execute" on lean activity creation',
  'permissions.hideSaveOnLeanServiceOrder.description':
    '**Web exclusive**. When enabled, hides the "Save" button on lean creation and leaves only "Save and execute", preventing activities from being registered without being executed. Disabled (default): shows both buttons.',
  'permissions.createChild.title': 'Child activity creation in app',
  'permissions.createChild.description':
    'Allows creation of child activities in app, whenever an activity is completed',
  'permissions.updateChecklistChildServiceOrder.title': 'Allows changing checklist of child activities in app',
  'permissions.updateChecklistChildServiceOrder.description':
    'Allows changing checklist of child activities in app, whenever a child activity is being generated',
  'permissions.hideCheckinAndCheckout.title': 'Should hide checkin and checkout information',
  'permissions.hideCheckinAndCheckout.description': 'Hides checkin and checkout in activity summary and PDF',
  'permissions.hideAttendanceTime.title': 'Should hide attendance time information',
  'permissions.hideAttendanceTime.description': 'Hides attendance time in activity summary and PDF',
  'permissions.canExecuteFromWeb.title': 'Can execute activities from web',
  'permissions.canExecuteFromWeb.description': 'Allows user to execute activities in Btime web version',
  'permissions.canEditFinishedServiceOrders.title': 'Can edit finished activities',
  'permissions.canEditFinishedServiceOrders.description':
    'Allows user who already has edit permission to also edit finished activities',

  'permissions.bulkCreateServiceOrders.title': 'Create activities in bulk',
  'permissions.bulkCreateServiceOrders.description':
    '**Mobile app exclusive** Permission to create activities in mass.',

  'permissions.createServiceOrderWithoutUser.title': 'Allow creating activity without user',
  'permissions.createServiceOrderWithoutUser.description':
    '**Mobile app exclusive**. When enabled: user field is hidden. When disabled: user field is required.',

  'permissions.useBtimeAI.title': 'Btime AI access',
  'permissions.useBtimeAI.description': 'Allows accessing Btime AI to get insights and answers about operations',

  'permissions.refuseServiceOrder.title': 'Refuse activities',
  'permissions.refuseServiceOrder.description': '**Mobile app exclusive**. Can refuse to execute an activity.',

  'permissions.canCreateSlaToServiceOrder.title': 'Create SLA for activities',
  'permissions.canCreateSlaToServiceOrder.description': 'Allows creating SLA for activities',

  'permissions.hideServiceOrdersPlace.title': 'Save activities without place',
  'permissions.hideServiceOrdersPlace.description': 'Allows saving activities without place',

  'permissions.reviewServiceOrder.title': 'Reply recovery',
  'permissions.reviewServiceOrder.description': 'Allows recovering replies from last activity',

  'permissions.setupServiceOrderTag.title': 'Activity Tag',
  'permissions.setupServiceOrderTag.description': 'Can create, edit and remove activity tags',

  'permissions.editServiceOrdersName.title': 'Edit activity name',
  'permissions.editServiceOrdersName.description': 'Create and edit activities with name',

  'permissions.editServiceOrdersStatus.title': 'Status management',
  'permissions.editServiceOrdersStatus.description': 'Allows approve, cancel and reject',

  'permissions.executePublicServiceOrder.title': 'Public activity sending',
  'permissions.executePublicServiceOrder.description':
    'Allows sending by email for activity execution via public links',

  'permissions.seeOnlySelfServiceOrders.title': 'View only own activities',
  'permissions.seeOnlySelfServiceOrders.description': 'User will only be able to view own activities',

  'permissions.validateDuplicateServiceOrders.title': 'Duplicate activity validation',
  'permissions.validateDuplicateServiceOrders.description':
    'When creating activities in bulk, will check if similar activities already exist',

  'permissions.seeServiceOrdersResume.title': 'Summary view',
  'permissions.seeServiceOrdersResume.description': 'User can view activity summary',

  'permissions.seeServiceOrdersPublicResumeLink.title': 'Public link view',
  'permissions.seeServiceOrdersPublicResumeLink.description': 'User can view and copy public summary link',

  'permissions.useResumePdfHeaderImage.title': 'Header image in summary PDF',
  'permissions.useResumePdfHeaderImage.description': 'Allows adding or removing a header image in summary PDF',

  'permissions.useAutomaticDistribution.title': 'Automatic activity distribution',
  'permissions.useAutomaticDistribution.description': 'Allows using automatic activity distribution',

  'permissions.requirePauseReason.title': 'Make pause reason required',
  'permissions.requirePauseReason.description': 'Requires a reason for pause every time an activity is paused.',

  'permissions.createLocationsPlaceLevel.title': 'Allows creating place levels',
  'permissions.createLocationsPlaceLevel.description': 'Allows creating place levels',

  'permissions.seeRecordIds.title': 'Allows viewing record ids',
  'permissions.seeRecordIds.description': 'Allows viewing record ids from front',

  'permissions.canViewLabelTriggersCall.title': 'Allows viewing trigger error tags in activities',
  'permissions.canViewLabelTriggersCall.description': 'Allows viewing trigger error tags in activities',

  'permissions.canViewServiceOrderInternalId.title': 'Show internal #id on activities',
  'permissions.canViewServiceOrderInternalId.description':
    'Displays the record internal id (#id) above the activity yearly code on cards, modals and tables.',

  'permissions.seeServiceOrdersTimeline.title': 'View the timeline',
  'permissions.seeServiceOrdersTimeline.description': 'Allows viewing the timeline tab on activity details.',

  'permissions.seeServiceOrdersTriggerEvents.title': 'View trigger events',
  'permissions.seeServiceOrdersTriggerEvents.description':
    'Allows viewing the trigger events (shortcuts) tab on activity details.',

  'permissions.seeServiceOrdersAuditPanel.title': 'View the audit panel',
  'permissions.seeServiceOrdersAuditPanel.description': 'Allows viewing the audit tab on activity details.',

  'permissions.useNumberedPagination.title': 'Uses numbered pagination',
  'permissions.useNumberedPagination.description':
    'Disables infinite scroll and navigates table pages through navigation',

  'permissions.editFinishedServiceOrdersUser.title': 'Edits user of completed activities',
  'permissions.editFinishedServiceOrdersUser.description':
    'Allows changing user even of activities that have been completed or discontinued',

  'permissions.setupScreen.title': 'Manage screen views',
  'permissions.setupScreen.description': 'Allows creating, editing and removing screen views like kanban',

  'permissions.showExpiredContractWarning.title': 'Show expired contract alert',
  'permissions.showExpiredContractWarning.description':
    'Shows an alert in all listings, dashboard and map about contract pending.',

  'permissions.showBillingWarning.title': 'Show open invoice alert',
  'permissions.showBillingWarning.description':
    'Shows an alert in all listings, dashboard and map about existence of open invoice.',

  'permissions.showQRCodeOnModalDetails.title': 'Show QR Codes tab in Places and Assets',
  'permissions.showQRCodeOnModalDetails.description':
    'Allows displaying QR Codes tab in Places and Assets details modal.',

  'permissions.blockPastDates.title': 'Prevent past date selection',
  'permissions.blockPastDates.description': 'Prevents selecting dates before current day.',

  'permissions.setupDashboard.title': 'Manage dashboard screens',
  'permissions.setupDashboard.description': 'Allows creating, editing and removing dashboard screen views',

  'permissions.createUserGroup.title': 'Group creation',
  'permissions.createUserGroup.description': 'Can create new user groups',

  'permissions.requireUserGroup.title': 'Required group',
  'permissions.requireUserGroup.description': 'Every user must be part of a group',

  'permissions.changePassword.title': 'Change password',
  'permissions.changePassword.description': 'Can change user passwords',

  'permissions.createChecklistType.title': 'Type creation',
  'permissions.createChecklistType.description': 'Can create new checklist types',

  'permissions.requireChecklistType.title': 'Required type',
  'permissions.requireChecklistType.description': 'Every checklist must have a type',

  'permissions.showUndoOption.title': 'Undo',
  'permissions.showUndoOption.description': 'Enables undo option for last changes during checklist creation',

  'permissions.createXsPlaceLevel.title': 'Allows creating place levels',
  'permissions.createXsPlaceLevel.description': 'Allows creating place levels',

  'permissions.seeConfidentialFields.title': 'Allows viewing confidential fields',
  'permissions.seeConfidentialFields.description': 'Allows viewing confidential additional fields',

  'permissions.completeNonCompliance.title': 'Complete non-compliance',
  'permissions.completeNonCompliance.description': 'Can manually complete non-compliances',
  'permissions.reopenNonCompliance.title': 'Reopen non-compliance',
  'permissions.reopenNonCompliance.description': 'Can manually reopen non-compliances',

  'permissions.useAvailabilityPanel.title': 'Use Availability Panel',
  'permissions.useAvailabilityPanel.description':
    'Enables the Places Availability menu and panel in place of the Non-compliances flow.',
  'permissions.editPlaceAvailabilityStatus.title': 'Allow changing a place status manually',
  'permissions.editPlaceAvailabilityStatus.description':
    'Enables the manual availability status change button on the list, kanban and place details, including dragging cards between columns.',
  'permissions.notificationAlert.title': 'Enable notification alert',
  'permissions.notificationAlert.description': 'Emits a notification when there is a new activity.',
  'permissions.switchChecklistNameByYearlyId.title': 'Switch checklist name by activity id',
  'permissions.switchChecklistNameByYearlyId.description':
    'Displays activity id instead of checklist name in summary and PDF',

  'permissions.removeGeneralStock.title': 'Manual General Stock Adjustment',
  'permissions.removeGeneralStock.description': 'Manual quantity and value adjustment.',

  'permissions.canUseDateKanbanSuggestion.title': 'Date suggestion in kanban',
  'permissions.canUseDateKanbanSuggestion.description':
    'Suggestion of opening, scheduling and completion dates in Kanban',

  'permissions.canUseTwilioIntegration.title': 'Twilio',
  'permissions.canUseTwilioIntegration.description': 'Allows accessing and configuring Twilio integration',

  'permissions.enablePlaceLock.title': 'Place locking',
  'permissions.enablePlaceLock.description': 'Enables place locking when creating activity.',

  'permissions.requireUnproductiveServiceOrderSignature.title': 'Signature for Unproductive Activity',
  'permissions.requireUnproductiveServiceOrderSignature.description':
    'Requires signature when changing an activity to unproductive.',

  'permissions.validateDuplicateServiceOrdersOnApp.title': 'Enable duplicate alert on App',
  'permissions.validateDuplicateServiceOrdersOnApp.description':
    'Displays an alert in the app when trying to create a duplicate activity.',

  'permissions.configureAssetQrCodeMenuRules.title': 'Configure Asset QR Code menu rules by type and place',
  'permissions.configureAssetQrCodeMenuRules.description':
    'Allows configuring the Asset QR Code menu by asset type and place, enabling multiple combined rules instead of a single menu for all assets.',

  'modules.general.title': 'General settings',
  'modules.assets.title': 'Assets',
  'modules.dynamicServiceOrders.title': 'Dynamic Activities',
  'modules.stocks.title': 'Stock',
  'modules.masks.title': 'Masks',
  'modules.templates.title': 'Document templates',
  'modules.refunds.title': 'Refunds',
  'modules.dashboard.title': 'Dashboard',
  'modules.users.title': 'Users',
  'modules.checklists.title': 'Checklists',
  'modules.serviceOrders.title': 'Activities',
  'modules.maps.title': 'Map',
  'modules.fleets.title': 'Fleets',
  'modules.triggers.title': 'Automations',
  'modules.routines.title': 'Routines',
  'modules.segments.title': 'Segmentations',
  'modules.locations.title': 'Places',
  'modules.people.title': 'People',
  'modules.forms.title': 'Forms',
  'modules.qrcode.title': 'QR Codes',
  'modules.nonCompliances.title': 'Non-compliances',
  'modules.availability.title': 'Places Availability',
  'modules.availability.description': 'Places availability panel',
  'modules.integrations.title': 'Integrations',
  'modules.qrcode.description': 'QR Code management',
  'modules.nonCompliances.description': 'View all non-compliances',
  'modules.publicToken.title': 'Public pages and APIs',
  'modules.publicToken.description': 'View public token',
  'modules.router.description': 'Routing',

  title: 'Permissions',
  all: 'All',
  enable: 'Enable',
  disable: 'Disable',
  errorUpdatingPermission: 'An error occurred while updating the permission'
}

export default TRANSLATE
